export const LICENSE_HQ = "https://pravadhgx.pravadhlabs.com";

export const IMAGES = {
  backend: "ghcr.io/dhairyasalesforce/pravadh-gx-backend",
  frontend: "ghcr.io/dhairyasalesforce/pravadh-gx-frontend",
  agent: "ghcr.io/dhairyasalesforce/pravadh-gx-agent",
  mongo: "mongo:7",
};

export const YOU_RECEIVE = [
  "A license pack from Pravadh: LICENSE_INSTANCE_ID, INSTALL_TOKEN (once), LICENSE_SECRET",
  "A GitHub PAT with read:packages only, so you can pull private images",
  "Image names and a release tag (usually stable)",
  "This handbook — orchestration only, never application source",
];

export const YOU_GENERATE = [
  "JWT_SECRET and TOKEN_ENCRYPTION_KEY on the new server",
  "Superadmin / admin passwords for this instance",
  "Your own LLM API key in /admin/instance after login",
  "Your own mailer key if you want email (Resend or equivalent)",
];

export const NEVER_COPY = [
  "Any .env from Pravadh HQ or from a different customer",
  "HQ Razorpay, Resend, Anthropic, OpenAI, Mongo, or JWT values",
  "Git repository access, SSH passwords, or source trees",
  "Salesforce Connected App secrets that belong to another org",
];

export function licensePack(created = {}) {
  return {
    origin: LICENSE_HQ,
    id: created.instance_id || "INSTANCE_ID_FROM_HQ",
    token: created.install_token || "INSTALL_TOKEN_FROM_HQ",
    secret: created.license_secret || "LICENSE_SECRET_FROM_HQ",
    domain: created.domain || "gx.customer.com",
  };
}

export function generateSecretsCommands() {
  return `# Run on the customer server. These keys belong to this instance only.
python3 -c 'import secrets; print("JWT_SECRET=" + secrets.token_urlsafe(48))'
python3 -c 'import os,base64; print("TOKEN_ENCRYPTION_KEY=" + base64.urlsafe_b64encode(os.urandom(32)).decode())'
python3 -c 'import secrets; print("ADMIN_PASSWORD=" + secrets.token_urlsafe(16))'
python3 -c 'import secrets; print("SUPERADMIN_PASSWORD=" + secrets.token_urlsafe(16))'`;
}

export function ghcrLoginCommands() {
  return `# Private images. PAT must be read:packages — never repo or admin scope.
export GHCR_USER=dhairyasalesforce
export GHCR_PULL_TOKEN='PASTE_READ_PACKAGES_TOKEN'
echo "$GHCR_PULL_TOKEN" | docker login ghcr.io -u "$GHCR_USER" --password-stdin
# Podman: echo "$GHCR_PULL_TOKEN" | podman login ghcr.io -u "$GHCR_USER" --password-stdin`;
}

export function registerCommands(created) {
  const p = licensePack(created);
  return `curl -fsSL -X POST ${p.origin}/api/license/register \\
  -H "Content-Type: application/json" \\
  -d '{"install_token":"${p.token}","hostname":"'"$(hostname)"'"}'`;
}

export function composeInstallCommands(created) {
  const p = licensePack(created);
  return `# Any Linux VM (Ubuntu, RHEL, Amazon Linux, on-prem). Images only — never git clone.
# Works with Docker Engine + Compose plugin, or Podman + podman-compose (same file).

sudo apt-get update
sudo apt-get install -y ca-certificates curl python3
curl -fsSL https://get.docker.com | sudo sh

export GHCR_USER=dhairyasalesforce
export GHCR_PULL_TOKEN='PASTE_READ_PACKAGES_TOKEN'
export LICENSE_HQ_URL=${p.origin}
export LICENSE_INSTANCE_ID=${p.id}
export INSTALL_TOKEN=${p.token}
export LICENSE_SECRET=${p.secret}
export GX_DOMAIN=${p.domain}

(curl -fsSL "$LICENSE_HQ_URL/api/public/install.sh" || curl -fsSL "$LICENSE_HQ_URL/install.sh") | sudo env \\
  LICENSE_HQ_URL="$LICENSE_HQ_URL" \\
  LICENSE_INSTANCE_ID="$LICENSE_INSTANCE_ID" \\
  INSTALL_TOKEN="$INSTALL_TOKEN" \\
  LICENSE_SECRET="$LICENSE_SECRET" \\
  GX_DOMAIN="$GX_DOMAIN" \\
  GHCR_USER="$GHCR_USER" \\
  GHCR_PULL_TOKEN="$GHCR_PULL_TOKEN" \\
  bash`;
}

export function k8sCommands(created) {
  const p = licensePack(created);
  return `# Any Kubernetes / OpenShift / EKS / AKS / GKE cluster.
# Orchestration only — never git clone. Secret is YOUR generated .env, not HQ keys.

kubectl create namespace pravadh-gx --dry-run=client -o yaml | kubectl apply -f -

curl -fsSL ${p.origin}/api/public/customer.env.example -o .env
# Fill LICENSE_* from HQ, generate JWT/Fernet/passwords locally, set URLs to ${p.domain}

echo "$GHCR_PULL_TOKEN" | kubectl create secret docker-registry ghcr \\
  --docker-server=ghcr.io --docker-username="$GHCR_USER" --docker-password="$GHCR_PULL_TOKEN" \\
  -n pravadh-gx --dry-run=client -o yaml | kubectl apply -f -

kubectl -n pravadh-gx create secret generic gx-env --from-env-file=.env --dry-run=client -o yaml | kubectl apply -f -
curl -fsSL ${p.origin}/api/public/customer-k8s.yml | sed "s/gx.customer.com/${p.domain}/g" | kubectl apply -f -

curl -fsSL -X POST ${p.origin}/api/license/register \\
  -H "Content-Type: application/json" \\
  -d '{"install_token":"${p.token}","hostname":"k8s-${p.domain}"}'

# Point ${p.domain} at your Ingress. Add TLS with cert-manager or your load balancer.`;
}

export function anyRuntimeCommands(created) {
  const p = licensePack(created);
  return `# Any host that can run OCI images: Docker, Podman, nerdctl, containerd, ECS, Nomad.
# Architecture: YOUR reverse proxy → frontend:80 and backend:8000. Mongo stays private.

# 1) Generate .env on this server (see secrets commands). LICENSE_* from HQ only.
# 2) Login to GHCR with the read:packages token.
# 3) Pull images — still no source.

docker pull ${IMAGES.mongo}
docker pull ${IMAGES.backend}:stable
docker pull ${IMAGES.frontend}:stable
docker pull ${IMAGES.agent}:stable

docker network create gx || true
docker volume create gx_mongo || true

docker run -d --name pravadh_gx_mongo --restart unless-stopped --network gx \\
  -v gx_mongo:/data/db ${IMAGES.mongo}

docker run -d --name pravadh_gx_backend --restart unless-stopped --network gx \\
  --env-file .env -e MONGO_URL=mongodb://pravadh_gx_mongo:27017 \\
  -v /opt/pravadh-gx/exports:/app/exports ${IMAGES.backend}:stable

docker run -d --name pravadh_gx_frontend --restart unless-stopped --network gx \\
  ${IMAGES.frontend}:stable
# If the frontend is not published on 80, your proxy should send:
#   /api  → pravadh_gx_backend:8000
#   /     → pravadh_gx_frontend:80

# Optional auto-update agent (needs a Docker socket). Skip on Kubernetes.
docker run -d --name pravadh_gx_agent --restart unless-stopped --network gx \\
  --env-file .env -v /var/run/docker.sock:/var/run/docker.sock \\
  -v /opt/pravadh-gx:/opt/gx -w /opt/gx ${IMAGES.agent}:stable

curl -fsSL -X POST ${p.origin}/api/license/register \\
  -H "Content-Type: application/json" \\
  -d '{"install_token":"${p.token}","hostname":"${p.domain}"}'`;
}

export function moveServerCommands() {
  return `# Moving THIS customer instance to a new server (same license).
# You may copy LICENSE_* and the Mongo volume from the old customer box.
# You must NOT copy anything from Pravadh HQ.

# On the old server
docker compose -f /opt/pravadh-gx/deploy/customer-compose.yml --env-file /opt/pravadh-gx/.env stop
docker run --rm -v gx_mongo:/data -v /tmp:/backup mongo:7 tar czf /backup/gx-mongo.tgz -C /data .
# Copy /opt/pravadh-gx/.env and /tmp/gx-mongo.tgz to the new server with YOUR scp — not HQ keys.

# On the new server
# 1) Pull the same private images (GHCR read:packages token).
# 2) Place .env at /opt/pravadh-gx/.env (mode 600). Keep LICENSE_INSTANCE_ID + LICENSE_SECRET.
# 3) Restore Mongo, then start compose / k8s / docker run as before.
docker volume create gx_mongo
docker run --rm -v gx_mongo:/data -v /tmp:/backup mongo:7 tar xzf /backup/gx-mongo.tgz -C /data
# 4) Point DNS at the new IP. Old box can be retired.
# 5) If you start a fresh database instead, generate new JWT/Fernet and first-login passwords.`;
}

export function afterInstallNotes(created) {
  const p = licensePack(created);
  return `# DNS A/AAAA: ${p.domain} → this server. Then TLS (Caddy, nginx, ALB, certbot).
# First login: SUPERADMIN_EMAIL / SUPERADMIN_PASSWORD from THIS server's .env
# Brand + your LLM: https://${p.domain}/admin/instance
# Billing, trial dates, lock, and revoke stay at Pravadh HQ.`;
}
